import { useNavigate } from 'react-router-dom';

const SessionTimeout = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/login/otp');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#EEE1E8] to-[#DCCFD7]">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-lg text-center">
        <div className="mb-6">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-10 h-10 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-[#621C43] mb-2">Session Timeout</h1>
          <p className="text-gray-600 text-lg">
            Your session has expired. Please login again to continue.
          </p>
        </div>
        <button
          onClick={handleLogin}
          className="w-full py-3 px-4 bg-[#EA600E] text-white rounded-md hover:bg-orange-600 transition font-medium"
        >
          Login Again
        </button>
      </div>
    </div>
  );
};

export default SessionTimeout;
